import { ExpandOutlined, FullscreenExitOutlined } from '@ant-design/icons';
import { Form, Modal } from 'antd';
import React, { useState } from 'react';
import "./styles.scss";

const EditEntityForm = ({ visible, onSubmit, addEditModalFooter, defaultShowAddEditExpandButton = false, onCancel, title, creationInProgress, defaultValue = {}, done, modalDetails, contentClassName, newModalDetails, fetchAllEntities, formSchema = [] }) => {
    const [isExpanded, setIsExpanded] = useState(defaultShowAddEditExpandButton);
    const [form] = Form.useForm();
    React.useEffect(() => {
        form.setFieldsValue(defaultValue)
    }, [form, defaultValue])

    console.log("defaultShowAddEditExpandButton", defaultShowAddEditExpandButton);

    return (
        <Modal
            visible={visible}
            title={title}
            className={`ant-admin-modal ${contentClassName} ${isExpanded ? "antd-modal-content-expanded" : "antd-modal-content-notexpanded"}`}
            okText={(defaultValue && defaultValue._id != 'new') ? "Update" : "Create"}
            okButtonProps={{
                disabled: creationInProgress
            }}
            cancelText="Cancel"
            onCancel={onCancel}
            onOk={() => {
                form
                    .validateFields()
                    .then((values) => {
                        // todo: not sure why id gets stripped
                        values._id = defaultValue._id;
                        onSubmit(values, form);
                    })
                    .catch((info) => {
                        console.log('Validate Failed:', info);
                    });
            }}
        >
            {defaultShowAddEditExpandButton !== undefined && <div className="expanded-div" onClick={() => setIsExpanded(!isExpanded)}>
                {isExpanded ? <FullscreenExitOutlined /> : <ExpandOutlined />}
            </div>}

            <Form
                form={form}
                layout="vertical"
                name="form_in_modal"
                initialValues={defaultValue}>
                {
                    formSchema.map((schema: any, i) => {
                        const Component = schema.component;
                        let componentChildren = null;
                        if (schema.componentProps)
                            if (typeof schema.componentProps.updateLatestChildren === "function") {
                                componentChildren = schema.componentProps.updateLatestChildren()
                            } else {
                                componentChildren = schema.componentProps.children || componentChildren
                            }
                        return Component ?
                            <Form.Item key={`EntityForm-${i}`} {...schema.props}>
                                <Component {...schema.componentProps} form={form} done={done} formDefaultValue={defaultValue || ""}>
                                    {componentChildren}
                                </Component>
                            </Form.Item>
                            : null
                    })
                }
            </Form>

            {defaultValue?._id !== "new" && modalDetails && modalDetails({ ...defaultValue }, form, fetchAllEntities)}
            {defaultValue?._id === "new" && newModalDetails && newModalDetails({ ...defaultValue }, form)}

        </Modal>
    );
};

export default EditEntityForm;
